/*
* @Author: yongwenhao
* @Date: 2020-04-17 09:23:11
* @describe: 联系我们邮箱列表
*/
<template>
    <div class="email-list">
        <el-button type="primary" @click="onAdd">添加</el-button>
        <el-table :data="tableData" style="width: 100%">
            <el-table-column label="序号" type="index" width="100"></el-table-column>
            <el-table-column prop="receiverName" label="姓名" width="200" show-overflow-tooltip></el-table-column>
            <el-table-column prop="email" label="邮箱" show-overflow-tooltip></el-table-column>
            <el-table-column prop="typeName" label="类型" show-overflow-tooltip></el-table-column>
            <el-table-column fixed="right" label="操作" width="120">
                <template slot-scope="scope">
                    <el-button
                            @click.native.prevent="onEdit(scope.row)"
                            type="text"
                            size="small">
                        修改
                    </el-button>
                    <el-button
                            @click.native.prevent="onDel(scope.row)"
                            type="text"
                            size="small">
                        删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <EmailAddEdit v-model="isShow" :infoFrom="infoFrom" @on-update="onUpdate"></EmailAddEdit>
    </div>
</template>

<script>
    import EmailAddEdit from './edit-add'
    import {GetReceiverList, DelReceiver} from '../../api/email'

    export default {
        name: "list",
        components: {EmailAddEdit},
        data() {
            return {
                isShow: false,
                tableData: [],
                infoFrom: {}
            }
        },
        methods: {
            init() {
                GetReceiverList().then(res => {
                    if (res.status) {
                        res.data.forEach(item => {
                            item.typeName = item.type === 1 ? '合作表单' : item.type === 2 ? '媒体与投资者' : '职位申请';
                        });
                        this.tableData = res.data || [];
                    }
                })
            },
            onUpdate() {
                this.init();
            },
            onAdd() {
                this.isShow = true;
                this.infoFrom = {}
            },
            onEdit(params) {
                this.infoFrom = params;
                this.isShow = true
            },
            onDel(params) {
                this.$confirm("确认删除?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        DelReceiver(params.receiverId).then((res) => {
                            if (res.status) {
                                this.$message({
                                    type: "success",
                                    message: "删除成功!",
                                });
                                this.init()
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消删除",
                        });
                    });
            }
        },
        mounted() {
            this.init()
        }
    }
</script>

<style lang='less' scoped>

</style>
